import React from 'react';
import {
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  Chip
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

const ComplianceMetricsCard = ({ complianceMetrics }) => {
  if (complianceMetrics.totalDuties === 0) {
    return null;
  }

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CheckCircle color="primary" />
        Duty Roster Compliance (Last 30 Days)
      </Typography>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom variant="body2">
                Total Duties
              </Typography>
              <Typography variant="h4">{complianceMetrics.totalDuties}</Typography>
              <Typography variant="caption" color="textSecondary">
                Scheduled/In Progress/Completed
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom variant="body2">
                Compliant Duties
              </Typography>
              <Typography variant="h4" color="success.main">
                {complianceMetrics.compliantDuties}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                {complianceMetrics.totalDuties > 0 
                  ? `${((complianceMetrics.compliantDuties / complianceMetrics.totalDuties) * 100).toFixed(1)}% compliance rate`
                  : '0% compliance rate'}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom variant="body2">
                Non-Compliant Duties
              </Typography>
              <Typography variant="h4" color="error.main">
                {complianceMetrics.nonCompliantDuties}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                Requires attention
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      
      {/* Aircraft Type Breakdown */}
      <Box sx={{ mt: 3 }}>
        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
          Compliance by Aircraft Type
        </Typography>
        <Grid container spacing={2}>
          {Object.entries(complianceMetrics.byAircraftType).map(([aircraftType, metrics]) => (
            metrics.total > 0 && (
              <Grid item xs={12} md={6} key={aircraftType}>
                <Card variant="outlined">
                  <CardContent>
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                      <Typography variant="h6">
                        {aircraftType}
                      </Typography>
                      <Chip
                        label={aircraftType === 'Fixed Wing' ? 'D7J-J4' : 'D7J-J2'}
                        size="small"
                        color={aircraftType === 'Fixed Wing' ? 'primary' : 'default'}
                        variant="outlined"
                      />
                    </Box>
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                      Total: {metrics.total} duties
                    </Typography>
                    <Box display="flex" gap={2} mt={1}>
                      <Box>
                        <Typography variant="caption" color="textSecondary">Compliant</Typography>
                        <Typography variant="h6" color="success.main">
                          {metrics.compliant}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography variant="caption" color="textSecondary">Non-Compliant</Typography>
                        <Typography variant="h6" color="error.main">
                          {metrics.nonCompliant}
                        </Typography>
                      </Box>
                    </Box>
                    {metrics.total > 0 && (
                      <Box sx={{ mt: 1 }}>
                        <Typography variant="caption" color="textSecondary">
                          Compliance Rate: {((metrics.compliant / metrics.total) * 100).toFixed(1)}%
                        </Typography>
                      </Box>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            )
          ))}
        </Grid>
      </Box>
    </Paper>
  );
};

export default ComplianceMetricsCard;

